import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../Farms.css";

function Farms() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="farms-page">
      <nav className="page-nav">
        <Link to="/" className="nav-back">&larr; Zenbul</Link>
      </nav>

      <section className="farms-hero">
        <h1>Zenbul Farms</h1>
        <p>
          A modular, automated, and sustainable farming unit that grows
          high-caloric crops and can be deployed anywhere in the world.
        </p>
      </section>

      <section className="farms-content">
        <img
          src={process.env.PUBLIC_URL + "/module.png"}
          alt="Zenbul Farming Unit"
          className="farms-module-img"
        />
        <button
          className="farms-details-btn"
          onClick={() => setIsModalOpen(true)}
        >
          View Details
        </button>
      </section>

      <section className="farms-contact">
        <h2>Get In Touch</h2>
        <p>Reach out at hello@zenbul.com for collaborations or interest.</p>
      </section>

      {isModalOpen && (
        <div className="modal-overlay" onClick={() => setIsModalOpen(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button
              className="modal-close"
              onClick={() => setIsModalOpen(false)}
            >
              &times;
            </button>
            <img
              src={process.env.PUBLIC_URL + "/infoGraphic.png"}
              alt="Zenbul Farming Unit Details"
              className="modal-img"
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default Farms;
